import { Box } from "@mui/material";

import { Incident } from "types/Incident";
import { IncidentViewerIncidentPanelFootage } from "./IncidentViewerIncidentPanelFootage";
import { useMemo } from "react";
import { DateTime } from "luxon";

interface TabPanelProps {
    id: string;
    show: boolean;
    children?: React.ReactNode;
}

function TabPanel(props: TabPanelProps) {
    return (
        <div
            id={props.id}
            role="tabpanel"
            hidden={!props.show}
            style={{
                flexBasis: "100%",
                overflow: "scroll",
            }}
        >
            {props.show && <Box sx={{ p: 3 }}>{props.children}</Box>}
        </div>
    );
}

export interface IncidentViewerIncidentPanelProps {
    incident: Incident;
    show: boolean;
}

export function IncidentViewerIncidentPanel(
    props: IncidentViewerIncidentPanelProps,
) {
    // sort footage on timestamp ASC
    const sortedFootage = useMemo(() => {
        if (!props.incident.footage || props.incident.footage.length === 0) {
            return [];
        }

        return props.incident.footage
            .slice()
            .sort(
                (a, b) =>
                    DateTime.fromISO(a.timestamp).valueOf() -
                    DateTime.fromISO(b.timestamp).valueOf(),
            );
    }, [props.incident.footage]);

    return (
        <TabPanel
            key={`tabpanel-${props.incident.id}`}
            id={`tabpanel-${props.incident.id}`}
            show={props.show}
        >
            <Box
                sx={{
                    display: "flex",
                    gap: 2,
                }}
            >
                {sortedFootage?.map((footage) => (
                    <IncidentViewerIncidentPanelFootage
                        key={footage.id}
                        footage={footage}
                    />
                ))}
            </Box>
        </TabPanel>
    );
}
